// components/InstallGuide.jsx
import { useState, useEffect } from 'react';

import { os } from '../utils/browser';
import instruction1 from '../assets/images/t1.png';
import instruction2 from '../assets/images/t2.png';
import close from '../assets/images/close.png';
import useGameStore from '../stores/game.store';

const DISMISSED_KEY = 'ig-dont-remind';

const InstallPrompt = () => (
  <>
    Play Fishing Frenzy natively
    <br />
    <br />
    Add it to your home screen for the best experience!
  </>
);

const InstallModal = ({ onClose, onInstall, onDontRemind }) => (
  <div className="ig-modal-backdrop" onClick={onClose}>
    <div
      className="instruction-wrapper"
      style={{ position: 'relative', height: '100%' }}
      onClick={(e) => e.stopPropagation()}>
      {os.toLowerCase() === 'android' ? (
        <div className="pop-android">
          <div className="toptext">
            <span>Install Game</span>
          </div>
          <div className="pop2-android">
            <div className="instruction-text-android">
              <InstallPrompt />
            </div>
          </div>
          <div className="install-btn-wrapper">
            <button className="install-button" onClick={onInstall}>
              <span>Install</span>
            </button>
            <div className="ig-dont-remind sub-title" onClick={onDontRemind}>
              Don't remind me again
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: `url(${close})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0% 0%',
              backgroundSize: '100% 100%',
              position: 'absolute',
              right: '-10px',
              top: '-20px',
              width: '40px',
              height: '42px',
              outline: 'none',
              border: 'none',
            }}
          />
        </div>
      ) : (
        <div className="pop">
          <div className="toptext">
            <span>Install Game</span>
          </div>
          <div className="pop2">
            <div className="instruction-text">
              <InstallPrompt />
            </div>
            <div className="content-container">
              <div className="instruction-step-wrapper">
                <div className="step-wrapper">
                  <div className="d-flex gap-2 justify-content-round">
                    <div className="d-flex flex-column justify-content-between align-items-center flex-fill">
                      <span className="sub-title">
                        Step <p className="d-inline step">1</p>
                      </span>
                      <img src={instruction1} className="step-image" alt="" />
                    </div>
                    <div className="d-flex gap-3 flex-column justify-content-round align-items-center flex-fill">
                      <span className="sub-title">
                        Step <p className="d-inline step">2</p>
                      </span>
                      <img src={instruction2} className="step-image" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="ig-dont-remind sub-title" onClick={onDontRemind}>
                Don't remind me again
              </div>
            </div>
          </div>
          <button
            className="btn text-light py-2 popup-notification-btn-close"
            onClick={onClose}
            style={{
              background: `url(${close})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0% 0%',
              backgroundSize: '100% 100%',
              position: 'absolute',
              right: '-10px',
              top: '-20px',
              width: '40px',
              height: '42px',
              outline: 'none',
              border: 'none',
            }}
          />
        </div>
      )}
    </div>
  </div>
);

const InstallGuide = () => {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISSED_KEY) === 'true');
  const [errorMessage, setErrorMessage] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const isGameLoaded = useGameStore((state) => state.isGameLoaded);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  useEffect(() => {
    if (!errorMessage) return;
    const t = setTimeout(() => setErrorMessage(null), 5000);
    return () => clearTimeout(t);
  }, [errorMessage]);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((result) => {
        if (result.outcome === 'accepted') setOpen(false);
        setDeferredPrompt(null);
      });
    } else {
      setErrorMessage('App already installed.');
      setOpen(false);
    }
  };

  const handleDontRemind = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setHidden(true);
    setOpen(false);
  };

  if (!isGameLoaded || hidden) return null;

  return (
    <>
      <button className="Play-button ig-fab press-start-2p-regular" onClick={() => setOpen(true)}>
        <span>Install Game</span>
      </button>

      {errorMessage && (
        <div className="login-error-message">
          <span>⛔ Error! ⛔</span>
          <br />
          <span>{errorMessage}</span>
        </div>
      )}

      {open && (
        <InstallModal onClose={() => setOpen(false)} onInstall={handleInstall} onDontRemind={handleDontRemind} />
      )}
    </>
  );
};

export default InstallGuide;
